import * as Sentry from "@sentry/remix";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { I18nextProvider, initReactI18next } from "react-i18next";
import { useLocation, useMatches } from "react-router";
import { HydratedRouter } from "react-router/dom";
import { z } from "zod";
import { zodI18nMap } from "zod-i18n-map";
import zodPlTranslation from "zod-i18n-map/locales/pl/zod.json";

import { i18nextOptions } from "src/I18N/i18nextOptions";

import { I18nPackageBackendClient } from "./I18N/I18nPackageBackend.client";

Sentry.init({
  dsn: "https://c44e296f7fafc28f6a772c3c72e1f8bf@o4508749958152192.ingest.de.sentry.io/4508749965099088",
  enabled: process.env.NODE_ENV === "production",
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:\/\/api.sztama\.com/],
});

if (!i18next.isInitialized) {
  // eslint-disable-next-line import/no-named-as-default-member
  i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(I18nPackageBackendClient)
    .init({
      ...i18nextOptions,
      partialBundledLanguages: true,
      resources: {
        pl: {
          zod: zodPlTranslation,
        },
      },
      detection: {},
    })
    .then(() => {
      z.setErrorMap(zodI18nMap);
      // then hydrate your app wrapped in the I18nextProvider
      return hydrateRoot(
        document,
        <I18nextProvider i18n={i18next}>
          <HydratedRouter />
        </I18nextProvider>,
      );
    });
}
